import React, { useEffect } from "react";
import ComplaintForm from "./ComplaintForm";

// Overlay que renderiza o formulário completo de reclamação por cima da página atual.
// Full-screen no mobile, card centralizado no desktop. Fecha no X, no Esc e no clique fora.
export default function ComplaintModal({ initial, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden"; // trava o scroll do fundo enquanto o popup está aberto
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-black/60 p-0 sm:p-4"
      role="dialog" aria-modal="true" aria-label="Registrar relato"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="relative w-full bg-background shadow-2xl min-h-screen sm:my-4 sm:min-h-0 sm:max-w-2xl sm:rounded-2xl">
        <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-5 py-3 sm:rounded-t-2xl">
          <h2 className="text-lg font-bold text-text">Registrar relato</h2>
          <button onClick={onClose} aria-label="Fechar"
            className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" />
            </svg>
          </button>
        </div>
        <div className="px-4 py-5 sm:px-6">
          <ComplaintForm embedded initial={initial} onClose={onClose} />
        </div>
      </div>
    </div>
  );
}
